// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: "https://api.sanasumahealthcare.com/",
  imgUrl : "https://api.sanasumahealthcare.com/uploads/",
  company: "UT Labs",
  version: "1.0.0",
  develop: "Nilaksha",
};
 
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

// baseUrl: "https://api.sanasumahealthcare.com/",
// imgUrl : "https://api.sanasumahealthcare.com/",
// https://api.sanasuma.xyz/
// baseUrl: "http://192.168.8.102:3000/",
// imgUrl : "https://api.sanasumahealthcare.com/",
